import {useMemo} from 'react'
import {useQuery} from '@tanstack/react-query'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {useSsrFetchOrigin} from './use-ssr-fetch-origin'
import {buildQueryString, stableStringify} from './ssr-query-utils'

const fetchAvailabilityIndicators = async (origin, parameters) => {
    try {
        const response = await fetch(
            `${origin}/api/availability-indicators-ssr${buildQueryString(parameters)}`,
            {method: 'GET'}
        )

        if (!response.ok) {
            console.warn(`[Availability Indicators] Request failed with status ${response.status}`)
            return null
        }

        return response.json()
    } catch (error) {
        console.warn('[Availability Indicators] Request failed:', error)
        return null
    }
}

export const useAvailabilityIndicators = (productId, queryOptions = {}) => {
    const {site} = useMultiSite()
    const origin = useSsrFetchOrigin()
    const siteId = site?.id

    const parameters = useMemo(
        () => ({
            productId,
            siteId
        }),
        [productId, siteId]
    )

    const queryKey = useMemo(
        () => ['availability-indicators', stableStringify(parameters)],
        [parameters]
    )

    return useQuery({
        ...queryOptions,
        queryKey,
        queryFn: () => fetchAvailabilityIndicators(origin, parameters),
        enabled: Boolean(productId) && queryOptions.enabled !== false
    })
}
